// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class UpsearchModelPayorPayorUpsearchModel {
    static getAttributeTypeMap() {
        return UpsearchModelPayorPayorUpsearchModel.attributeTypeMap;
    }
}
UpsearchModelPayorPayorUpsearchModel.discriminator = undefined;
UpsearchModelPayorPayorUpsearchModel.attributeTypeMap = [
    {
        "name": "canUpdate",
        "baseName": "canUpdate",
        "type": "boolean"
    },
    {
        "name": "canInsert",
        "baseName": "canInsert",
        "type": "boolean"
    },
    {
        "name": "skipSearch",
        "baseName": "skipSearch",
        "type": "boolean"
    },
    {
        "name": "model",
        "baseName": "model",
        "type": "PayorUpsearchModel"
    }
];
//# sourceMappingURL=upsearchModelPayorPayorUpsearchModel.js.map